export default {
    required: "需要一个值",
    email: "该值不是有效的电子邮件地址",
    mask: "该值无效",
    maxValue: "最大值是 {max}",
    maxLength: "允许的最大长度为 {max}",
    regex: "该值无效",
    server: {
        DELEGATES_NOT_ENABLED: "此合作伙伴未启用代理功能。",
        DELEGATE_DOES_NOT_EXIST: "代理不存在",
        DELEGATE_UPDATE_PERMISSIONS_MISMATCH: "无法更新不属于您的委托。",
        DELEGATE_DELETE_PERMISSIONS_MISMATCH: "无法删除不属于您的代理。",
        DELEGATE_ALREADY_EXISTS: "已存在符合此条件的委托规则。",
        DELEGATE_CANNOT_BE_SELF: "您不能将自己添加为代理人。",
        IMPERSONATE_USER_NO_PERMISSIONS: "用户 {email} 没有 DXC Gear 的访问权限，无法代表其下单。",
        INVALID_CART_ITEM: "产品 {product} 不允许",
        INVALID_USER_TYPE: "用户类型不是员工",
        INVALID_EMPLOYMENT_STATUS: "用户并非在职员工",
        USER_NOT_FOUND: "用户未找到",
        "Invalid user type": "无效的用户类型",
        "User not found": "用户未找到"
    }
}